/* @ngInject */
export function routeConfig($urlRouterProvider, $locationProvider) {
  $urlRouterProvider.when('/', '/home');

  $urlRouterProvider.otherwise(($injector, $location) => {
    const url = $location.url();
    if (!['/', '/home'].includes(url)) {
      const user = $injector.get('Session').read('userinfo');
      if (!user) return $location.url(`/signin?continue=${encodeURIComponent(url)}`);
    }

    return $location.url('/home');
  });

  $locationProvider.html5Mode(true);
}



// WEBPACK FOOTER //
// ./client/app/app.config.js